import Button from './button';
import colorDialog from '../colorDialog';
import defaultsDeep from 'lodash-es/defaultsDeep';
import cloneDeep from 'lodash-es/cloneDeep';
import borw from '../../../borw';
import lookAndFeel from '../lookAndFeel';

var icon =
  "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3E%3Cpath fill='${iconColor}' d='M6.92,19L5,17.08L13.06,9L15,10.94M20.71,5.63L18.37,3.29C18,2.9 17.35,2.9 16.96,3.29L13.84,6.41L11.91,4.5L10.5,5.91L11.92,7.33L3,16.25V21H7.75L16.67,12.08L18.09,13.5L19.5,12.09L17.58,10.17L20.7,7.05C21.1,6.65 21.1,6 20.71,5.63Z' /%3E%3C/svg%3E";

export default class ColorPicker extends Button {

  onReady(){
    this.addTrigger('click',(event,control,cmp,anchor,[ev])=>{
      {
        if(this.isLayoutMode) {return;}

        this.raiseEvent('isExpanded',{value:true});
        let buttonStyle = lookAndFeel(control.originalLookAndFeel, '30.78px');
        colorDialog(ev, control.value, { alpha: true, buttonStyle }).then((newColor) => {
          this.raiseEvent('isExpanded',{value:false});
          var newHex = newColor.hex.substr(0, 7);
          // console.log('onDone', newHex, newColor);
          if (newHex !== control.value) {
            control.value = newHex;
            control.render();
          }
        });
      }
    });
    super.onReady();
  }

  renderElement() {
    const control = this;
    const options = this._controlOptions;
    // console.log('renderColorPicker', control, options, instance, path);

    if (!options.value) {
      options.value = {};
    }

    if (!options.value.defaultValue) {
      options.value.defaultValue = '#000000';
    }

    defaultsDeep(options, {
      label: { align: 'right' },
      icon: { position: 'left' },
      style: { normal: { width: '88px' } },
      lookAndFeel: {},
    });
    options.label.text = control.value;
    control.originalLookAndFeel = cloneDeep(options.lookAndFeel);
    options.lookAndFeel.background = control.value;
    options.lookAndFeel.foreground = borw(control.value);
    options.icon.url = icon.replace(
      '${iconColor}',
      options.lookAndFeel.foreground.replace('#', '%23')
    );   

    return super.renderElement();
  }
}
